import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { deleteCompany, editCompany, getCompany } from '../companyThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'company';

export const companySlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCompany });
        handleRequestThunk({ builder, request: editCompany });
        handleRequestThunk({ builder, request: deleteCompany, isDelete: true });
    },
});

export const company = companySlice.reducer;
